import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowShareRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-share-right, next, forward"} maskId="square-filled-radius-0-stroke-1-IconArrowShareRight"><path d="M11.7285 8.00426V2.41895L23.0005 12.0002L11.7285 21.5814V16.0026C7.81696 16.0409 5.67999 16.5344 4.35545 17.3071C3.00045 18.0975 2.43163 19.212 1.67573 20.7238L0.728516 20.5002C0.728516 16.23 1.34965 13.0674 3.16397 10.9843C4.92288 8.96479 7.70021 8.07129 11.7285 8.00426Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowShareRight;
